<div class="container-fluid">
  <div class="row align-items-stretch">

    <!-- Card 1 -->
    <div class="col-6 d-flex">
      <div class="card shadow-sm border-0 rounded-3 h-100 w-100">
        <div class="card-body d-flex align-items-center">
          <div class="row text-center w-100">

            <div class="col-md-4 border-end cursor-pointer" (click)="navigate('totalDoc')">
              <div class="d-flex flex-column align-items-center">
                <i class="mdi mdi-file-document-outline fs-2 text-primary mb-2"></i>
                <p class="text-muted mb-1">Total Documents</p>
                <h4 class="fw-bold mb-0">{{documentsCount?.total}}</h4>
              </div>
            </div>

            <div class="col-md-4 border-end cursor-pointer" (click)="navigate('signedDoc')">
              <div class="d-flex flex-column align-items-center">
                <i class="mdi mdi-check-circle-outline fs-2 text-success mb-2"></i>
                <p class="text-muted mb-1">Signed Documents</p>
                <h4 class="fw-bold mb-0">{{documentsCount?.signed}}</h4>
              </div>
            </div>

            <div class="col-md-4 cursor-pointer" (click)="navigate('pendingDoc')">
              <div class="d-flex flex-column align-items-center">
                <i class="mdi mdi-clock-outline fs-2 text-warning mb-2"></i>
                <p class="text-muted mb-1">Pending Documents</p>
                <h4 class="fw-bold mb-0">{{documentsCount?.pending}}</h4>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>

    <!-- Card 2 -->
    <div class="col-6 d-flex">
      <div class="card border-0 shadow-sm rounded-3 overflow-hidden h-100 w-100">

        <div class="row g-0 h-100">

          <div class="col-md-4 bg-primary text-white d-flex flex-column justify-content-center align-items-center p-3">
            <i class="mdi mdi-crown-outline fs-1 mb-2 text-warning"></i>
            <h5 class="fw-bold mb-2 text-white">
              {{planInfo?.plan}}
            </h5> <span class="badge bg-warning text-dark px-3 py-1">{{planInfo?.status}}</span>
          </div>

          <div class="col-md-8 p-4 d-flex flex-column justify-content-center">

            <div class="mb-3 d-flex justify-content-between align-items-center">
              <div>
                <small class="text-muted">Plan Expired</small>
                <div class="fw-semibold">
                  {{planInfo?.endDate}}
                </div>
              </div>

              <button class="btn btn-outline-primary btn-sm" (click)="navigate('plan')">
                Upgrade
              </button>
            </div>

            <div class="mb-3">
              <div class="d-flex justify-content-between">
                <span class="text-muted">Documents Usage</span>
                <span class="fw-semibold">{{planInfo?.documentsUsed}} / {{planInfo?.documentsLimit}}</span>
              </div>
              <div class="progress mt-1" style="height: 8px;">
                <div class="progress-bar bg-info"
                  [style.width.%]="calculatePercentage(planInfo.documentsUsed, planInfo.documentsLimit)"></div>
              </div>
            </div>

            <div>
              <div class="d-flex justify-content-between">
                <span class="text-muted">Users Usage</span>
                <span class="fw-semibold">{{planInfo?.usersUsed}} / {{planInfo?.usersLimit}}</span>
              </div>
              <div class="progress mt-1" style="height: 8px;">
                <div class="progress-bar bg-success"
                  [style.width.%]="calculatePercentage(planInfo.usersUsed, planInfo.usersLimit)"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>